import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Pais } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityPaisesAdapter: EntityAdapter<Pais> =
  createEntityAdapter<Pais>({
    selectId: (model) => model.codigo,
    sortComparer: (a: Pais, b: Pais): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityPaisesState extends EntityState<Pais> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityPaisesState =
  entityPaisesAdapter.getInitialState({
    isLoading: false,
    error: null
  });
